import { GridColDef } from '@mui/x-data-grid-pro';
import { DisplayMoney, DisplayNumber } from '@price-for-profit/data-grid';
import { MileageBucketDropdown } from './mileage-bucket-dropdown';

export const columnsFreight = ({ admin }: { admin: boolean }) => {
  const columns: GridColDef[] = [
    {
      headerName: 'Master Customer Name',
      field: 'masterCustomerCode',
      width: 180,
    },
    {
      headerName: 'Bill-To Customer Code',
      field: 'billToCustCode',
      width: 130,
    },
    {
      headerName: 'Bill-To Customer Name',
      field: 'billToCustName',
      width: 130,
    },
    {
      headerName: 'Revenue',
      field: 'revenue',
      width: 130,
      renderCell: DisplayMoney({ decimalScale: 0 }),
    },
    {
      headerName: 'Cases Sold',
      field: 'casesSold',
      width: 130,
      renderCell: DisplayNumber({ decimalScale: 0 }),
    },
    {
      headerName: 'City State',
      field: 'cityState',
      width: 130,
    },
    {
      headerName: 'Milage Bucket',
      field: 'mileageBucket',
      width: 130,
    },
    {
      headerName: 'Revised Milage Bucket',
      field: 'revisedMileageBucket',
      width: 130,
      cellClassName: 'drive-app-wps--cell--editable',
      editable: admin,
      renderEditCell: params => <MileageBucketDropdown {...params} />,
    },
    {
      headerName: 'Description',
      field: 'description',
      width: 140,
    },
    {
      headerName: 'Commodity',
      field: 'commodity',
      width: 140,
    },
    {
      headerName: 'Freight Per Case',
      field: 'freightPerCase',
      width: 150,
      renderCell: DisplayMoney(),
    },
    {
      headerName: 'Revised Freight Per Case',
      field: 'revisedFreightPerCase',
      width: 140,
      renderCell: DisplayMoney(),
    },
    {
      headerName: 'Estimated Annual Freight',
      field: 'estAnnualFreight',
      width: 140,
      renderCell: DisplayMoney({ decimalScale: 0 }),
    },
    {
      headerName: 'Estimate Revised Annual Freight',
      field: 'estRevisedAnnualFreight',
      width: 130,
      renderCell: DisplayMoney({ decimalScale: 0 }),
    },
    {
      headerName: 'Revised vs Current Freight',
      field: 'revisedVsCurrentFreight',
      width: 200,
      renderCell: DisplayMoney({ decimalScale: 0 }),
    },
  ];

  return columns;
};
